import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { getProfileQueryKey } from 'features/users/queries';
import { joinProgram } from '../../services';
import { getProgramQueryKey, getProgramsInfiniteQueryKey } from '../keys';

export const useJoinProgramMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { programId: string }>({
    async mutationFn({ programId }) {
      const { data } = await joinProgram({ routeParams: { id: programId } });
      return data;
    },
    async onSuccess(_, { programId }) {
      await queryClient.invalidateQueries({ queryKey: getProgramQueryKey({ programId }) });
      await queryClient.invalidateQueries({ queryKey: getProgramsInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
